import BaseModel from './base';

let localId = 1;
let localSignatures = [];

class SignatureModel extends BaseModel {
	fileUrl(id) {
		return this.basePath + `/${id}/file`;
	}

	upload(image, loggedIn) {
		if (!loggedIn) {
			const url = URL.createObjectURL(image);
			const id = localId++;

			localSignatures = [...localSignatures, { url, id }];

			return { id, url };
		}

		return this.post('/', {
			body: image
		});
	}

	list(loggedIn) {
		if (!loggedIn) {
			return localSignatures;
		}

		return this.get('');
	}

	async deleteById(id, loggedIn) {
		if (!loggedIn) {
			localSignatures = localSignatures.filter(
				signature => signature.id !== id
			);
		}

		return this.delete(`/${id}`);
	}

	clearLocalSignatures() {
		localSignatures = [];
	}
}

export default new SignatureModel('/signature');
